import { render } from "./IconFilm.vue?vue&type=template&id=13e58533"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconFilm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13e58533"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13e58533', __exports__)) {
    api.reload('13e58533', __exports__)
  }
  
  module.hot.accept("./IconFilm.vue?vue&type=template&id=13e58533", () => {
    api.rerender('13e58533', render)
  })

}


export default __exports__